/**
 * StickerCard — white card, thick 2px border, rounded, hard offset shadow.
 * tone changes shadow color. hover optional (sticker-hover class).
 */
const shadowByTone = {
  ink: "shadow-sticker-md",
  candy: "shadow-sticker-candy",
  pink: "shadow-sticker-pink",
  yellow: "shadow-sticker-yellow",
  mint: "shadow-sticker-mint",
};

const bgByTone = {
  paper: "bg-white",
  candy: "bg-candy-tint",
  pink: "bg-pink-tint",
  yellow: "bg-yellow-tint",
  mint: "bg-mint-tint",
  ink: "bg-ink text-white",
};

export const StickerCard = ({
  children,
  tone = "ink",
  bg = "paper",
  rounded = "2xl",
  hover = true,
  className = "",
  as: Tag = "div",
  ...rest
}) => {
  const r =
    rounded === "lg"
      ? "rounded-lg"
      : rounded === "xl"
        ? "rounded-xl"
        : rounded === "3xl"
          ? "rounded-3xl"
          : "rounded-2xl";
  return (
    <Tag
      className={`border-2 border-ink ${bgByTone[bg]} ${shadowByTone[tone]} ${r} ${hover ? "sticker-hover" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

/** DashboardPanel — sticker card with a header slot */
export const DashboardPanel = ({
  title,
  eyebrow,
  action,
  children,
  tone = "ink",
  bg = "paper",
  className = "",
}) => (
  <StickerCard tone={tone} bg={bg} hover={false} className={`p-6 md:p-7 ${className}`}>
    {(title || eyebrow || action) && (
      <div className="mb-5 flex items-start justify-between gap-3">
        <div>
          {eyebrow ? <span className="t-eyebrow block">{eyebrow}</span> : null}
          {title ? <h3 className="t-h2 mt-1 text-ink">{title}</h3> : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    )}
    {children}
  </StickerCard>
);

/** PlayfulChartCard — chart wrapper with colored underlay */
export const PlayfulChartCard = ({ children, tone = "candy", className = "" }) => {
  const bgTint = {
    candy: "bg-candy-tint",
    pink: "bg-pink-tint",
    yellow: "bg-yellow-tint",
    mint: "bg-mint-tint",
  }[tone];
  return (
    <div
      className={`relative rounded-2xl border-2 border-ink ${bgTint} p-4 shadow-sticker-md md:p-5 ${className}`}
    >
      <div className="relative rounded-xl border-2 border-ink bg-white p-4 md:p-5">{children}</div>
    </div>
  );
};

/** BlobContainer — organic rounded container for hero images/content */
export const BlobContainer = ({ children, tone = "candy", className = "" }) => {
  const bg = {
    candy: "bg-candy-tint",
    pink: "bg-pink-tint",
    yellow: "bg-yellow-tint",
    mint: "bg-mint-tint",
  }[tone];
  return (
    <div
      className={`relative border-2 border-ink ${bg} rounded-blob shadow-sticker-md ${className}`}
    >
      {children}
    </div>
  );
};

export default StickerCard;
